import React, { Component } from "react";

import "./index.scss";

import play from "../../assets/img/play.png";

import shadeImg from "../../assets/img2/shade.png";

class Item extends Component {
  render() {
    const imgSrc = this.props.imgSrc;
    const title = this.props.title;
    const link = this.props.link;
    const src = this.props.src;
    const id = this.props.id;
    const shade = this.props.shade;

    // const clickHandler = () => {
    //   if (link !== "") {
    //     window.open(link, "_blank");
    //   }
    // };

    const playHandler = () => {
      // this.props.onPortal();
      // console.log(id);
      this.props.onTemp(imgSrc, src, id);

      this.props.onWheel();
    };

    return (
      <div className="Item">
        <div className="imgBox">
          <img className="poster" src={imgSrc} alt="poster" />
          <img className="play" src={play} alt="play" onClick={playHandler} />
          {shade === 0 ? (
            <img className="shade" alt="play" src={shadeImg} />
          ) : (
            ""
          )}
        </div>
        <div className="Title">
          {/* <a href={link} target="_blank" rel="noreferrer">
            {title}
          </a> */}
          {link !== "" ? (
            <a href={link} target="_blank" rel="noreferrer">
              {title}
            </a>
          ) : (
            title
          )}
        </div>
      </div>
    );
  }
}

export default Item;
